import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {
  init as initSentry,
  globalHandlersIntegration,
  browserApiErrorsIntegration,
} from '@sentry/angular';
import { filterOutEventsBeforeSend } from './app/utils/exception-filter-functions';

if (environment.production) {
  enableProdMode();

  initSentry({
    dsn: environment.sentryDsn,
    environment: environment.branch || environment.tag,
    release: environment.sentryReleaseVersion,
    integrations: [
      globalHandlersIntegration({
        onunhandledrejection: true,
        onerror: true,
      }),
      browserApiErrorsIntegration({
        XMLHttpRequest: true,
      }),
    ],
    beforeSend: filterOutEventsBeforeSend,
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
